export default {
    path: '/terms',
    name: 'AppTerms',
    component: () => import('@/views/return_conditions/index.vue'),
    meta: {
        title: 'Условия возврата',
        forVisitors: true
    }
}